import { Modal, useModals } from 'almanac-ui/Modal'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { GraduationCap } from 'blaze-ui/icons'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { NoAccountsContent } from './NoAccountsFoundContent'
import { getConnectionGuide } from './utils'

export const NoAccountsFoundModal = ({
  provider,
  onClose,
}: {
  provider: ExternalIntegrationEnum
  onClose: () => void
}) => {
  const connectionGuide = getConnectionGuide(provider)
  const openWindowSafely = useOpenWindowSafely()
  const { closeModal } = useModals()
  const handleClose = () => {
    closeModal()
    onClose()
  }

  const footer = connectionGuide ? (
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button size="lg" variant="tertiary" onPress={handleClose}>
          Close
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button
          size="lg"
          variant="secondary"
          frontIcon={GraduationCap}
          onPress={() => openWindowSafely(connectionGuide)}
        >
          See Connection Guide
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  ) : (
    <Modal.Footer>
      <Modal.FooterContent slot="right">
        <Button size="lg" variant="tertiary" onPress={handleClose}>
          Close
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  )

  return (
    <Modal.Root onClose={handleClose}>
      <Modal.Header title="We couldn't find any accounts" />
      <Modal.Content>
        <NoAccountsContent provider={provider} />
      </Modal.Content>
      {footer}
    </Modal.Root>
  )
}
